import React from "react";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import TerrainIcon from "@material-ui/icons/Terrain";
import AttachMoneyIcon from "@material-ui/icons/AttachMoney";
import AspectRatioIcon from "@material-ui/icons/AspectRatio";
import FormatListNumberedIcon from "@material-ui/icons/FormatListNumbered";
import CategoryIcon from "@material-ui/icons/Category";

const useStyles = makeStyles(() => ({
  card: {
    borderRadius: 12,
    overflow: "hidden",
    border: "1px solid #e0e0e0",
    boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
    height: "100%",
  },
  header: {
    background: "linear-gradient(135deg, #2e7d32 0%, #43a047 100%)",
    padding: "14px 20px",
    display: "flex",
    alignItems: "center",
    gap: 10,
  },
  headerIcon: {
    color: "#fff",
    fontSize: 22,
  },
  headerTitle: {
    color: "#fff",
    fontSize: 14,
    fontWeight: 600,
    letterSpacing: 0.5,
    textTransform: "uppercase",
  },
  body: {
    padding: "16px 20px 20px",
    backgroundColor: "#fff",
  },
  costoBig: {
    textAlign: "center",
    padding: "16px 0 12px",
    borderBottom: "1px solid #f0f0f0",
    marginBottom: 8,
  },
  costoLabel: {
    fontSize: 10,
    color: "#90a4ae",
    textTransform: "uppercase",
    letterSpacing: 0.8,
    fontWeight: 600,
  },
  costoValue: {
    fontSize: 28,
    color: "#2e7d32",
    fontWeight: 700,
    lineHeight: 1.3,
  },
  row: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    padding: "10px 0",
    borderBottom: "1px solid #f0f0f0",
    "&:last-child": {
      borderBottom: "none",
    },
  },
  icon: {
    color: "#90a4ae",
    fontSize: 18,
    minWidth: 18,
  },
  label: {
    fontSize: 10,
    color: "#90a4ae",
    textTransform: "uppercase",
    letterSpacing: 0.8,
    fontWeight: 600,
    lineHeight: 1,
    marginBottom: 2,
  },
  value: {
    fontSize: 14,
    color: "#263238",
    fontWeight: 500,
    lineHeight: 1.3,
  },
  empty: {
    color: "#bdbdbd",
    fontStyle: "italic",
  },
}));

const fmtMoney = val =>
  "$" + parseFloat(val || 0).toLocaleString("es-MX", { minimumFractionDigits: 2 });

const InfoRow = ({ icon: Icon, label, value, classes }) => (
  <div className={classes.row}>
    <Icon className={classes.icon} />
    <div style={{ flex: 1 }}>
      <Typography className={classes.label}>{label}</Typography>
      <Typography className={value ? classes.value : `${classes.value} ${classes.empty}`}>
        {value || "—"}
      </Typography>
    </div>
  </div>
);

const DetailLot = ({ LoteInfo }) => {
  const classes = useStyles();

  return (
    <div className={classes.card}>
      <div className={classes.header}>
        <TerrainIcon className={classes.headerIcon} />
        <Typography className={classes.headerTitle}>Lote</Typography>
      </div>
      <div className={classes.body}>
        {/* Costo destacado */}
        <div className={classes.costoBig}>
          <Typography className={classes.costoLabel}>Valor del lote</Typography>
          <Typography className={classes.costoValue}>
            {fmtMoney(LoteInfo.COSTO)}
          </Typography>
        </div>

        <Grid container spacing={0}>
          <Grid item xs={6}>
            <InfoRow
              icon={FormatListNumberedIcon}
              label="Número de lote"
              value={LoteInfo.NUMERO != null ? String(LoteInfo.NUMERO) : null}
              classes={classes}
            />
          </Grid>
          <Grid item xs={6}>
            <InfoRow
              icon={CategoryIcon}
              label="Tipo de lote"
              value={LoteInfo.TIPO}
              classes={classes}
            />
          </Grid>
          <Grid item xs={12}>
            <InfoRow
              icon={AspectRatioIcon}
              label="Superficie"
              value={
                LoteInfo.SUPERFICIE != null
                  ? Number(LoteInfo.SUPERFICIE).toLocaleString("es-MX") + " m²"
                  : null
              }
              classes={classes}
            />
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

DetailLot.propTypes = {
  LoteInfo: PropTypes.object,
};
export default DetailLot;
